/**
 * GitHub repo / Cloudflare Pages slug from a business name.
 * Lowercase, hyphenated, punctuation stripped. Empty names fall back to `preview`.
 */
export function slugifyBusinessName(name: string, maxLen = 80): string {
  const raw = name
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['']/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
  const sliced = raw.slice(0, maxLen).replace(/-+$/g, '');
  return sliced || 'preview';
}

/** Cloudflare Pages: 1–58 chars, [a-z0-9-], no leading/trailing hyphen. */
export function cloudflareSlugFromName(name: string): string {
  let s = slugifyBusinessName(name, 58);
  if (!s) s = 'preview';
  if (s.length > 58) {
    s = s.slice(0, 58).replace(/-+$/g, '');
  }
  if (!s || /^-|-$/.test(s)) s = 'preview';
  return s;
}

export function emailSlugFromName(name: string): string {
  return slugifyBusinessName(name, 24).replace(/-/g, '') || 'business';
}
